/** Caches one successful Tool list and shares an in-flight request per panel. */
export function createAssistantToolsLoader<T>(fetchTools: () => Promise<T>) {
  let loaded = false
  let cachedTools: T
  let loading: Promise<T> | null = null

  async function load(): Promise<T> {
    if (loaded) return cachedTools
    if (!loading) {
      loading = fetchTools().then(
        (tools) => {
          cachedTools = tools
          loaded = true
          loading = null
          return tools
        },
        (error) => {
          loading = null
          throw error
        }
      )
    }

    return loading
  }

  return { load }
}
